import React, { type CSSProperties } from 'react';
import { InteractionPartUtils } from '@lib/models/InteractionPart';
import { ANALYTICS_AGENT_NAME } from '@lib/utils/environmentUtils';
import { LlmResponseRender } from '@lib/components';
import type { PartRendererProps } from './types';

const TextPart: React.FC<PartRendererProps> = ({ part, message, preview, onGoing, friendlyMode, onLinkClicked }) => {
    const textContent = InteractionPartUtils.getPartTextContent(part);
    const styleAutor: CSSProperties = part.author === ANALYTICS_AGENT_NAME
        ? { backgroundColor: "var(--background-paper)", padding: '20px 10px', borderRadius: '5px' }
        : { margin: '5px 0px', display: 'unset' };

    return (
        <div style={styleAutor}>
            <LlmResponseRender
                content={textContent ?? ""}
                partial={preview}
                sessionId={message.sessionId ?? 'ND'}
                onLinkClicked={onLinkClicked}
                message={message}
                onGoing={onGoing}
                friendlyMode={friendlyMode}
            />
        </div>
    );
};

export default TextPart;
